import React, { useEffect, useRef, useState } from 'react'
import "../Css/Whychooseus.css"

export default function Whychooseus() {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef(null);

 useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      });
    },
    { threshold: 0.1 }
  );

  const currentRef = containerRef.current;

  if (currentRef) {
    observer.observe(currentRef);
  }

  return () => {
    if (currentRef) {
      observer.unobserve(currentRef);
    }
  };
}, []);


  return (
    <div className="whychooseus-container" ref={containerRef}>
      <img src="/images/circle-1.png" alt="Decorative circle" className="circle-decoration circle-1" />
      <img src="/images/circle-2.png" alt="Decorative circle" className="circle-decoration circle-2" />
      
      <div className="excellence-badge">
        <svg className="star-icon" viewBox="0 0 24 24" fill="#2563EB">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
        <span className="excellence-text">Excellence Delivered</span>
      </div>
      
      <h2 className="main-heading">Why Choose Us</h2>
      
      <p className="description">
        We pride ourselves on providing cost-efficient development and timely delivery<br />
        for every project scope in the market.
      </p>

      <div className={`features-grid ${isVisible ? 'animate' : ''}`}>
        <div className="feature-cards">
          <img src="/images/cut-circle-1.png" alt="Decorative" className="card-corner-circle" />
          <div className="icon-wrapper icon-blue">
            <img src="/images/dollar.png" alt="Cost Efficient" />
          </div>
          <h3 className="feature-title">Cost Efficient</h3>
          <p className="feature-description">
            We provide cost-efficient, high-quality digital solutions for businesses of all sizes.
          </p>
        </div>

        <div className="feature-cards">
          <img src="/images/cut-circle-2.png" alt="Decorative" className="card-corner-circle" />
          <div className="icon-wrapper icon-purple">
            <img src="/images/experts.png" alt="Tech Experts" />
          </div>
          <h3 className="feature-title">Tech Experts</h3>
          <p className="feature-description">
            We are skilled professionals in the latest cutting-edge technologies.
          </p>
        </div>

        <div className="feature-cards">
          <img src="/images/cut-circle-3.png" alt="Decorative" className="card-corner-circle" />
          <div className="icon-wrapper icon-red">
            <img src="/images/ontime.png" alt="On Time Delivery" />
          </div>
          <h3 className="feature-title">On Time Delivery</h3>
          <p className="feature-description">
            Record of building enterprise class software on a given span of timeframe
          </p>
        </div>

        <div className="feature-cards">
          <img src="/images/cut-circle-4.png" alt="Decorative" className="card-corner-circle" />
          <div className="icon-wrapper icon-blue-light">
            <img src="/images/support.png" alt="24/7 Support" />
          </div>
          <h3 className="feature-title">24/7 Support</h3>
          <p className="feature-description">
            We support our clients 24/7 and maintaining the application for long term.
          </p>
        </div>
      </div>

      <div className={`stats-section ${isVisible ? 'animate' : ''}`}>
        <div className="stat-items">
          <h3 className="stat-numbers stat-blue">100+</h3>
          <p className="stat-label">Projects Completed</p>
        </div>

        <div className="stat-items">
          <h3 className="stat-numbers stat-purple">93%</h3>
          <p className="stat-label">Client Retention</p>
        </div>

        <div className="stat-items">
          <h3 className="stat-numbers stat-green">24/7</h3>
          <p className="stat-label">Support Available</p>
        </div>
      </div>
    </div>
  )
}